import { Button, Col, Form, Input, Row, Select, Tooltip } from "antd";
import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const FormFilter = ({ form, submit, loading, options }) => {
  const { t } = useTranslation()

  return (
    <>
      <Form layout="vertical" form={form} onFinish={submit}>
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item name="name" label={t('name')}>
              <Input style={{ width: '200px' }} placeholder={t('name')} />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="type"
              label={t('type')}
            >
              <Select
                options={options.map(item => ({
                  ...item,
                  label: t(item.label),
                }))}
              />
          </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={2}>
              <Form.Item>
                <Tooltip title={t('search')}>
                  <Button loading={loading} style={{ width: "100%" }} htmlType="submit" type="primary">
                    <SearchOutlined />
                  </Button>
                </Tooltip>
              </Form.Item>
            </Col>
        </Row>
      </Form>
    </>
  );
};

export default FormFilter;
